export enum TaskInfoStatus {
  NotReceived = 'Not Received',
  UnderReview = 'Under Review',
  Denied = 'Denied',
  Resubmit = 'Resubmit',
  PastDue = 'Past Due',
  Accepted = 'Accepted',
  Canceled = 'Canceled',
}
